import Footer from "./Footer";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import "../css/layout.css"

export default function Layout() {
  return (
    <div className='page'>
      <Header />
      <div style={{ minHeight: '600px' }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}
